export interface User {
    email: string;
    first_name: string;
    last_name: string;
    name: string;
    id: string;
    lang: string;
    is_superuser: boolean;
}

export enum MEMBERSHIP_STATUS {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export interface Membership {
    id: string;
    updated_at: string;
    created_at: string;
    user: User;
    status: MEMBERSHIP_STATUS;
    role: string;
    sp_role: {
        id: string;
        name: string;
    };
    parking: string;
    guest_reasons: [];
}

export interface Invitation {
    id: string;
    updated_at: string;
    created_at: string;
    email: string;
    role: string;
    sp_role: {
        id: string;
        name: string;
    };
    inviter: User;
    expires_at: string;
}
